

import React, { useState, useEffect, useContext } from 'react';
import { Card, Space, DatePicker, Switch, Select, Tag, Button, Typography, Table, Skeleton, Descriptions, Checkbox, Popover, Modal } from 'antd';

import { Location, GlobalContext, useTranslation, ApiUtils } from 'soxo-bootstrap-core';

import GuestInfo from '../../../common/components/guest-info/guest-info';

// import { GlobalContext } from "../../../../Store";

import { Tabs } from 'antd';

import moment from 'moment-timezone';

import { Registrations } from '../../../../models/';

// import './appointments.scss';

import { ReloadOutlined } from '@ant-design/icons';
import AuditLogList from '../../../audit-log/audit-log';

const { RangePicker } = DatePicker;

const { TabPane } = Tabs;

export default function RegistrationDetail(props) {

    const { user = {} } = useContext(GlobalContext);

    const [loading, setLoading] = useState(false);

    const { id } = props.match.params; //Get pagination number

    const [guest, setGuest] = useState({});

    const [guestdr, setGuestDoctorAppointment] = useState({});

    const [guestitm, setGuestItem] = useState({});

    const [guestpreReg, setGuestPreReg] = useState({});

    const [guestevent, setGuestEvent] = useState({});

    const [nature, setNature] = useState();

    const { t, i18n } = useTranslation();   // To Translate to another language

    var urlParams = Location.search();

    console.log(props.match.params);

    //PatiantData fetching function
    async function getRegistrations(id) {
        setLoading(true);

        Registrations.getRegistrationRecord(id).then((result) => {


            setGuest(result.result);
            if (result.result.drAppointment) setGuestDoctorAppointment(result.result.drAppointment); //Doctor Appoointment
            if (result.result.drAppointment && result.result.drAppointment.item) setGuestItem(result.result.drAppointment.item); //Item and Package
            if (result.result.drAppointment && result.result.drAppointment.preReg) setGuestPreReg(result.result.drAppointment.preReg); //Pre Registration
            if (
                result.result.drAppointment &&
                result.result.drAppointment.opbill &&
                result.result.drAppointment.opbill.Eventtran &&
                result.result.drAppointment.opbill.Eventtran.eventsubmas
            )
                setGuestEvent(result.result.drAppointment.opbill.Eventtran.eventsubmas); //Eventtran

            //Set Patient nature
            if (result.nature) setNature(result.nature)
            console.log(result.result);

            setLoading(false);
        });
    }

    useEffect(() => {
        if (user) {
            getRegistrations(id);

            // getPatientDetails(pageNo, range); //Patiant list get function
        }
    }, [user]);

    function refresh() {
        getRegistrations(id);
    }


    return (
        <Card className="appointments">
            {/* Page Header */}

            <div className="page-header">
                <div className="left">
                    {/* <Title style={{ marginBottom: '0px' }} level={3}>
                        {t('Registration')}
                    </Title> */}
                </div>
                <div className="right">
                    {/* Audit Log */}
                    <div>
                        {props.auditLog?.mode ? <>
                            <AuditLogList id={guest.op_id} props={props}  record_id={id} />
                        </> : null}
                    </div>
                    {/* <Button
                        onClick={() => {
                            Location.navigate({ url: `/new-registration/guest?da_id=${guest.drAppointment.da_id}&da_packagetypevalue=${guest.drAppointment.da_packagetypevalue}&prereg_id=${guest.drAppointment.da_referenceid}&prereg_opno=${id}&edit=true` });

                        }}
                        type="secondary" size={'small'}
                    >
                        Edit Registration
                    </Button> */}
                    <Button onClick={refresh} type="secondary" size={'small'}>
                        <ReloadOutlined />
                    </Button>
                </div>
            </div>
            {/* Page Header Ends */}

            <p className="size-hint">{/* {loading ? 'Loading' : patients.length} records. */}</p>

            {/* Content Below */}
            {loading ? (
                <Card>
                    <Skeleton active />
                </Card>
            ) : (
                <>
                    {/* <Tabs onChange={callback} type="card"> */}
                    {/* <GuestRecord record={guest} /> */}
                    {/* <GuestInfo guestreg={guest} guestdr={guestdr} guestitm={guestitm} guestevent={guestevent} guestprereg={guestpreReg} /> */}

                    {/* </Tabs> */}
                    <div>
                        <div className="registration-timeline-guest">
                            <div className="guest-detail">
                                {/*Guest Information */}
                                <GuestInfo
                                    guestreg={guest}
                                    guestdr={guestdr}
                                    guestitm={guestitm}
                                    guestevent={guestevent}
                                    guestprereg={guestpreReg}
                                    params={props.match}
                                    urlParams={urlParams}
                                    nature={nature}
                                    // Temporary flag to disable questionnaire
                                    disableQuestionnaire={true}
                                />
                            </div>

                            {/*Appointment Timeline */}
                            {/* <AppointmentTimeline guest={guestdr} guestopreg={guest} guestitem={guestitm} /> */}
                        </div>
                    </div>
                </>
            )}
        </Card>
    );
}

function GuestRecord({ record }) {
    const { t, i18n } = useTranslation();   // To Translate to another language
    function goQues(id, edit) {
        let payload = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization:
                    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6ImRlbW8iLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL3VzZXJkYXRhIjoiZmY6MToxOmRlczpzdWIiLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL2V4cGlyYXRpb24iOiJTdW5kYXksIEF1Z3VzdCAxLCAyMDIxIiwibmJmIjoxNjI1MjMzNjA0LCJleHAiOjE2Mjc4MjU2MDQsImlhdCI6MTYyNTIzMzYwNH0.mY0Mlv9eBNUDupmvRlIX6roqLzLafkPjIQE8b23JdCs:demo',
            },
        };

        return fetch(`${process.env.REACT_APP_OLD_BACKEND_URL}/doctorappointment/Getkey?id=${id}`, payload)
            .then((res) => res.json())
            .then((res) => {
                if (edit) {
                    window.open(`${process.env.REACT_APP_QUES_KEY}/staff/questionnaire?id=${id}&key=${res.Result}&edit=true`, '_blank');
                } else {
                    window.open(`${process.env.REACT_APP_QUES_KEY}/staff/questionnaire?id=${id}&key=${res.Result}`, '_blank');
                }
            })
            .catch((error) => {
                return;
            });
    }

    return (
        <>
            {record.op_id ? (
                <Card className="card-shadow card">
                    <Descriptions>
                        <Descriptions.Item label={t("Name")}>
                            <strong>
                                {record.op_fname} {record.op_lname} ({record.op_gender}) - {record.op_age}
                            </strong>
                        </Descriptions.Item>
                        <Descriptions.Item label={t("Mobile")}>{record.op_phone}</Descriptions.Item>
                        <Descriptions.Item label={t("Date")}>{moment(record.op_dt).format('DD/MM/YYYY')}</Descriptions.Item>
                        <Descriptions.Item label={t("Package Name")}>{record.drAppointment && record.drAppointment.da_packagetypevalue}</Descriptions.Item>
                        <Descriptions.Item label={t("Questionnaire Status")}>
                            {record.drAppointment && record.drAppointment.da_questfilled === 'F' ? (
                                <div>
                                    {record.drAppointment.da_questfilled}
                                    <br />
                                    <Button
                                        size="small"
                                        type="primary"
                                        onClick={() => {
                                            goQues(record.drAppointment.da_id, true);
                                        }}
                                    >
                                        {t('Edit Questionnaire')}
                                    </Button>
                                </div>
                            ) : (
                                <Button
                                    size="small"
                                    type="primary"
                                    onClick={() => {
                                        goQues(record.drAppointment.da_id);
                                    }}
                                >
                                    {t('Start Questionnaire')}
                                </Button>
                            )}
                        </Descriptions.Item>
                        <Descriptions.Item label={t("Payment Status")}>
                            {record.drAppointment && record.drAppointment.da_billid ? 'Billed' : 'Pending'}
                        </Descriptions.Item>
                        <Descriptions.Item label={t("Billing Status")}>
                            {/* <Button
                                className="billing"
                                onClick={() => {
                                    // proceedBilling();
                                }}
                                type="secondary"
                                shape="round"
                                style={{ background: "#FAC141" }}
                                // size="small"
                                color="green"
                            >
                                Proceed for Billing
                            </Button> */}
                        </Descriptions.Item>

                        <Descriptions.Item label={t("Current Status")}>{record.da_status}</Descriptions.Item>
                        <Descriptions.Item label={t("Current Status Remarks")}>{record.drAppointment.da_remarks}</Descriptions.Item>
                    </Descriptions>
                </Card>
            ) : null}
        </>
    );
}
